const en = {
  metaTitle: "Voice Lab",
  title: "Voice Lab",
  description: "Compare text-to-speech providers on your own sentences — Moroccan Darija, Egyptian, Saudi, French, English… — then choose which voice speaks each language in AI calls, separately for female and male personas.",
  back: "AI & credits",
  open: "Open Voice Lab",

  providersTitle: "Providers",
  providersDesc: "Paste an API key for each provider you want to try. Keys are stored encrypted on the server and never shown again.",
  keyLabel: "API key",
  keyPlaceholder: "Paste a new key",
  keySaved: "Key saved ({hint})",
  keyEnv: "Key from server environment ({hint})",
  keyMissing: "No key",
  saveKey: "Save",
  removeKey: "Remove key",
  tune_stability: "Stability",
  tune_similarityBoost: "Similarity",
  tune_style: "Style",
  tune_speed: "Speed",
  tuneReset: "Reset",
  tuneHint: "Natural conversation: stability ≈ 0.5 (lower = more expressive, higher = steadier), similarity ≈ 0.75, style 0 (higher adds latency), speed 0.95–1.05. Eleven v3 only uses stability 0, 0.5 or 1. These settings are saved with the voice when you press “Use”.",
  customTuning: "Adjust voice settings",
  ownSettingsHint: "Using each voice’s own saved settings — the ones its samples were made with. Turn on “Adjust voice settings” only if you want to change them.",
  fixesTitle: "Pronunciation fixes · {lang}",
  fixesHint: "When a word is read wrong (e.g. Darija الخلاص read like Standard Arabic), write it the way it should sound — add a sukun (ْ) or shadda (ّ), drop the vowel, or spell it phonetically. Listen tries these before you save; once saved, calls use them too.",
  fixWord: "Word",
  fixSay: "Say it as",
  fixAdd: "+ Add word",
  verifiedWith: "verified with {model}",
  voiceFor: "Voice for",
  defaultFor: "All {gender} personas (default)",
  colPersonas: "Personas",
  usesDefault: "uses the {gender} default",
  modelLabel: "Model",
  getKey: "Get a key",
  saved: "Saved.",

  labTitle: "Listen & compare",
  labDesc: "Pick a language or dialect, a gender and a provider, load its voices and press Listen. The time shows how long the provider took (lower is better for calls).",
  language: "Language / dialect",
  gender: "Persona",
  female: "Female",
  male: "Male",
  sampleText: "Sentence to read",
  resetSample: "Reset sample",
  provider: "Provider",
  loadVoices: "Load voices",
  searchPlaceholder: "Filter by name or accent",
  noVoices: "No voices found for this filter.",
  noKey: "Add a key for this provider first.",
  listen: "Listen",
  stop: "Stop",
  preview: "Provider sample",
  latency: "{ms} ms",
  use: "Use for {lang} · {gender}",
  inUse: "In use",
  sourceLibrary: "Library",
  sourceAccount: "My voices",
  sourceBuiltin: "Built-in",
  voiceCount: "{count} voices",

  assignmentsTitle: "Voices used in calls",
  assignmentsDesc: "A dialect without its own voice uses the Arabic (الفصحى) row. A persona never gets a voice of the other gender; with no voice set, calls use browser voices of the right gender or captions.",
  colLanguage: "Language",
  notSet: "Not set",
  clear: "Remove",
  fallsBack: "Uses {lang}",
};

export default en;
